import React from "react";
import Navbar from "../../components/base/landing/navbar";
import FooterLanding from "../../components/base/landing/footer";
import Adultos from "../../components/base/landing/adultos";
import WhatsApp from "../../components/base/whatsapp";
import BlogButton from "../../components/base/blog";


const AdultosPage = () => {
    return (
      <>
        <Navbar />
        <Adultos/>
        <FooterLanding/>
        <BlogButton/>
        <WhatsApp/>
      </>
    );
  };
  
  export default AdultosPage;